import * as L from 'leaflet';
import { UserLocation } from 'model/users-locations';

export interface UserLocationDataMarkerControllerOptions {
  getStandardMarkerIcon(userLocation: UserLocation): L.Icon
  highlightMarkerIcon: L.Icon,
  popupContent: string
}
